import type { PlayerProgress, StudentKP } from '../shared/types';
import { isDueToday } from '../shared/student-kp';

const MAX_DUE = 3;

export function dueKPsToday(progress: PlayerProgress, nowISO: string = new Date().toISOString()): StudentKP[] {
  if (!progress.studentKPs) return [];
  return progress.studentKPs
    .filter(kp => isDueToday(kp, nowISO))
    .sort((a, b) => a.box - b.box || a.nextReviewISO.localeCompare(b.nextReviewISO))
    .slice(0, MAX_DUE);
}

export function totalDueCount(progress: PlayerProgress, nowISO: string = new Date().toISOString()): number {
  if (!progress.studentKPs) return 0;
  return progress.studentKPs.filter(kp => isDueToday(kp, nowISO)).length;
}
